import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class CommonInfoService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_common_info(step: string): any {
    this.logger.info('COMMON_INFO | get_common_info | step: ' + step)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: new HttpParams().set('step', step),
      withCredentials: true,
    }

    return this.http.get(`${Backend.HOST_CONTAINER + Backend.COMMON_INFO}`, httpOptions).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error(
          'COMMON_INFO | get_common_info | catchError | errorMessage: ' + errorMessage,
        )
        return of(errorMessage)
      }),
    )
  }

  add_stage(stage: number): any {
    this.logger.info('COMMON_INFO | add_stage | stage: ' + stage)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const stageData = {
      stage: stage,
    }

    return this.http
      .post(`${Backend.HOST_CONTAINER + Backend.COMMON_INFO}`, stageData, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('COMMON_INFO | add_stage | catchError | errorMessage: ' + errorMessage)
          return of(errorMessage)
        }),
      )
  }
}
